import ThemeProvider from './ThemeProvider';
export * from './theme';
export default ThemeProvider;
